import { $keycloak, forceUpdateToken } from "@/plugins/keycloak"
import { Actions, store } from "@/store"

export default async (to, _from, next: (...args) => void): Promise<void> => {
  const auth = $keycloak.authenticated
  if (!auth) {
    next()
    return
  }

  let justLoggedIn = false
  const createAccount = to.meta.createAccount || to.params?.accountId === "undefined"
  if (to.hash && to.hash.includes("#state")) {
    const sessionState = to.hash.split("session_state=")[1].split("&")[0]

    justLoggedIn = await setLogin({ sessionState, createAccount })
    to.hash = ""
    to.href = to.href.split("#state")[0]
    to.fullPath = to.fullPath.split("#state")[0]
  } else if (to.name === "InviteUser" && !to.query.login) {
    justLoggedIn = await setLogin({ sessionState: $keycloak.sessionId || "", createAccount })
  }

  if (justLoggedIn && to.params?.accountId !== "undefined" && !to.query.login) {
    next({
      path: to.path,
      query: { ...to.query, login: "true" },
      replace: true
    })
    return
  }
  next()
}

const setLogin = async ({
  sessionState,
  createAccount
}: {
  sessionState: string
  createAccount: boolean
}): Promise<boolean> => {
  let sessionStateCached: string | null = null

  if (!createAccount) {
    sessionStateCached = localStorage.getItem("sessionState")
  } else {
    sessionStateCached = null
    localStorage.setItem("sessionState", "")
  }

  if (sessionState !== sessionStateCached) {
    localStorage.setItem("sessionState", sessionState)
    await store.dispatch(Actions.LOGIN)
    await forceUpdateToken()
    return true
  }
  return false
}
